const state = {
  borrow_id: null,
  refreshCommentList: false,
  comment_uuid: null,
  open_comment_modal: false,
  toggle_edit_comment_modal: false
}

const actions = {}

const mutations = {
  setBorrowId (state, id) {
    state.borrow_id = id
  },
  setRefreshCommentList () {
    state.refreshCommentList = !state.refreshCommentList
  },
  setCommentUuid (state, uuid) {
    state.comment_uuid = uuid
  },
  openCommentModal (state) {
    state.open_comment_modal = !state.open_comment_modal
  },
  toggleEditCommentModal (state) {
    state.toggle_edit_comment_modal = !state.toggle_edit_comment_modal
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
